import React, { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Dialog } from "@headlessui/react";
import PriceRangeMobile from "./PriceRangeMobile";
import BedMobileRefinement from "./BedMobileRefinement";
import BathMobileRefinement from "./BathMobileRefinement";
import PropertyTypeMobile from "./PropertyTypeMobile";
import ListingTypeMobile from "./ListingTypeMobile";
import {
  useClearRefinements,
  useCurrentRefinements,
} from "react-instantsearch-hooks-web";
import TownFilterMobile from "./TownFilterMobile";
import { useRouter } from "next/router";

export default function MobileFilterModal({
  open,
  setOpen,
  listingType,
  setListingType,
  scrollArea,
}) {
  const router = useRouter();
  const clearAllFilters = useClearRefinements();
  const props = useCurrentRefinements();
  const [color, setColor] = useState("blue");

  useEffect(() => setColor("red"), []);

  //  console.log(open)

  //  let [isOpen, setIsOpen] = useState(true)
  let initialFocusRef = useRef(null);

  return (
    <>
      <AnimatePresence>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          className="relative z-50"
          initialFocus={initialFocusRef}
          unmount={false}
        >
          <motion.div className="fixed inset-0 bg-white" aria-hidden="true" />

          <div className="fixed inset-0  flex flex-col space-y-6">
            <div className="flex h-[100svh] flex-col space-y-0 ">
              <div className=" flex h-[3.5rem] flex-shrink-0 items-center justify-between border border-b px-5">
                <span
                  onClick={() => {
                    setOpen(!open);
                  }}
                  className=" cursor-pointer font-semibold text-zote-primary"
                >
                  Close
                </span>
                <span className=" font-semibold">Filters</span>
                <span
                  onClick={() => {
                    if (props?.items?.length > 0) {
                      clearAllFilters.refine();
                    }
                  }}
                  className={
                    " cursor-pointer font-semibold " +
                    (props?.items?.length
                      ? " text-zote-blue"
                      : " text-blue-200")
                  }
                >
                  Reset
                </span>
              </div>

              <div
                ref={initialFocusRef}
                className=" flex h-full flex-col space-y-6 overflow-y-auto   px-5 py-8"
              >
                <ListingTypeMobile
                  listingType={listingType}
                  setListingType={setListingType}
                />
                <div className=" flex h-auto flex-shrink-0 flex-col space-y-2 ">
                  <label className=" text-lg font-semibold text-gray-800">
                    Price range
                  </label>
                  <PriceRangeMobile listingType={listingType} />
                </div>
                <div className=" flex h-auto flex-shrink-0 flex-col space-y-2 ">
                  <label className=" text-lg  font-semibold text-gray-800">
                    Bedrooms
                  </label>
                  <BedMobileRefinement />
                </div>
                <div className=" flex h-auto flex-shrink-0 flex-col space-y-2  ">
                  <label className=" text-lg font-semibold text-gray-800">
                    Bathrooms
                  </label>
                  <BathMobileRefinement />
                </div>
                <div className=" flex h-auto flex-shrink-0 flex-col space-y-2">
                  <label className=" text-lg font-semibold text-gray-800">
                    Home type
                  </label>
                  <PropertyTypeMobile />
                </div>

                {color && !router?.pathname?.startsWith("/town") ? (
                  <div className=" flex h-auto flex-shrink-0 flex-col space-y-2">
                    <label className=" text-lg font-semibold text-gray-800">
                      Towns
                    </label>

                    <TownFilterMobile />
                  </div>
                ) : null}
              </div>
              <div className=" flex h-20 flex-shrink-0 items-start bg-white px-5 pt-2 ">
                <button
                  onClick={() => {
                    setOpen(!open);
                  }}
                  className="  w-full rounded-md bg-zote-primary py-4 text-lg font-semibold tracking-wide text-gray-100"
                >
                  See Homes
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      </AnimatePresence>
    </>
  );
}
